export default __webpack_public_path__ + "c277e7835cbaa0bddd8be026428dbcde.ttf";